import Parse from 'html-react-parser';

function BMP20145(props) {
    let svgCode =
    `<svg width="64" height="120" viewBox="0 0 64 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="30.4" height="40" fill="${props.darkFill}"/>
        <rect x="33.6" y="80" width="30.4" height="40" fill="${props.darkFill}"/>
        <path d="M19 12L13 20L19 28M13 20L19 28" stroke="${props.highlightColour}" stroke-width="5"/>
        <path d="M19 53L13 60.5L19 68" stroke="white" stroke-width="5"/>
        <path d="M19 92L13 99.5L19 107M13 99.5L19 107" stroke="white" stroke-width="5"/>
        <path d="M46 107L52 99.5L46 92M52 99.5L46 92" stroke="${props.highlightColour}" stroke-width="5"/>
        <path d="M46 68L52 60.5L46 53M52 60.5L46 53" stroke="white" stroke-width="5"/>
        <path d="M46 28L52 20L46 12M52 20L46 12" stroke="white" stroke-width="5"/>
    </svg>`

    props.svgReturn(51, svgCode, "bmp00145", 64, 120);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20145;